import React from 'react'
import { Link } from 'react-router-dom'
import Reveal, { MaskLines } from './Reveal'

/** Near-black editorial banner opening every inner page. */
const PageHeader = ({ index, label, lines, description, crumb }) => (
  <section className="relative overflow-hidden bg-ink-950 bg-glow grain">
    <div className="absolute inset-0 hairgrid" aria-hidden="true" />

    <div className="container relative pb-20 pt-40 md:pb-28 md:pt-52">
      <Reveal className="flex items-baseline gap-4">
        {index && <span className="index-num text-paper-100/40">{index}</span>}
        <span className="label label-dark">{label}</span>
      </Reveal>

      <MaskLines as="h1" className="display-1 mt-10 max-w-5xl text-paper-100" lines={lines} />

      {description && (
        <Reveal delay={320}>
          <p className="mt-10 max-w-xl text-lg leading-relaxed text-paper-100/55">
            {description}
          </p>
        </Reveal>
      )}

      <Reveal delay={400}>
        <nav
          aria-label="Breadcrumb"
          className="mt-14 flex items-center gap-3 border-t border-paper-100/12 pt-6 text-xs text-paper-100/40"
        >
          <Link to="/" className="transition-colors hover:text-paper-100">
            Home
          </Link>
          <span aria-hidden="true">/</span>
          <span className="text-paper-100/70">{crumb}</span>
        </nav>
      </Reveal>
    </div>
  </section>
)

export default PageHeader
